<script lang="ts">
  import { Ingresos, Laboratorio, type Ingreso, type OrdenLab } from '../../../lib/api';

  export type TimelineItem = { hora: string; titulo: string; detalle: string; tipo: 'ingreso' | 'lab' | 'info' };

  let { limit = 10 }: { limit?: number } = $props();
  let items = $state<TimelineItem[]>([]);
  let error = $state<string | null>(null);

  function fmt(iso?: string | null) {
    if (!iso) return '—';
    try {
      return new Date(iso).toLocaleString('es-GT', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
    } catch { return iso; }
  }

  async function cargar() {
    error = null;
    try {
      const [ingresos, lab] = await Promise.all([
        Ingresos.activos(),
        Laboratorio.ordenes('VALIDADA').catch(() => [] as OrdenLab[]),
      ]);
      const timeline: TimelineItem[] = [];
      for (const i of ingresos as Ingreso[]) {
        timeline.push({
          hora: fmt(i.ingresadoEn),
          titulo: 'Ingreso activo',
          detalle: i.diagnosticoIngreso ?? `Paciente ${i.pacienteId.slice(0, 8)}`,
          tipo: 'ingreso',
        });
      }
      for (const o of (lab as OrdenLab[]).slice(0, 5)) {
        timeline.push({
          hora: fmt(o.facturadoEn),
          titulo: `Lab ${o.numero ?? ''}`.trim(),
          detalle: `${o.pacienteNombre ?? 'Paciente'} · validada`,
          tipo: 'lab',
        });
      }
      items = timeline.slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header><h3>Actividad reciente</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if items.length === 0 && !error}<p class="empty">Sin actividad reciente.</p>{:else}
    <ol>
      {#each items as it, i (i)}
        <li class={it.tipo}>
          <time>{it.hora}</time>
          <div>
            <strong>{it.titulo}</strong>
            <span>{it.detalle}</span>
          </div>
        </li>
      {/each}
    </ol>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--glass-border); border-radius: var(--radius-xl); background: var(--glass-bg-card); backdrop-filter: var(--glass-blur); -webkit-backdrop-filter: var(--glass-blur); box-shadow: var(--glass-shadow); overflow: hidden; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--glass-border); background: rgba(255,255,255,0.35); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
  h3 { margin: 0; font-size: 0.88rem; font-weight: 700; }
  header button { border: 1px solid var(--glass-border); background: var(--glass-bg-card); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-weight: 600; transition: all 0.2s; }
  header button:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  ol { list-style: none; margin: 0; padding: 0; max-height: 320px; overflow: auto; }
  li { display: flex; gap: 0.65rem; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--glass-border); align-items: flex-start; transition: background 0.15s; }
  li:hover { background: rgba(255,255,255,0.35); }
  time { font-size: 0.72rem; color: var(--text-secondary); white-space: nowrap; min-width: 6.5rem; }
  strong { display: block; font-size: 0.85rem; color: var(--text-primary); }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  li.ingreso strong { color: var(--danger); }
  li.lab strong { color: var(--info); }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
